import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import { ValidatorForm } from "react-material-ui-form-validator";
import { Autocomplete } from "@mui/material";
import "react-phone-input-2/lib/style.css";
import TextField from "@material-ui/core/TextField";
import SaveButton from "../../givBee/buttons/SaveButton";
import Button from "@material-ui/core/Button";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Utils from "../../../provider/Utils";
import AdminFetchServerData from "../../../provider/AdminFetchServerData";
import store from "../../../redux/store";
import AdminMenuWithBreadScrum from "../adminMenu/AdminMenuWithBreadScrum";
import PtsAlert from "../../givBee/ptsAlert/PtsAlert";
import CancelIconButton from "../../givBee/buttons/CancelIconButton";

class AccountTollfreeNumber extends Component {
  header = store.getState().adminHeader.adminHeader;
  appUserRoleList = store.getState().appUserRole.appUserRoleList;
  title = "Tollfree Number";
  breadCrumb = [
    { pageid: "/accountList", uiname: "Accounts List" },
    { pageid: "/viewAccount", uiname: "Account" },
    { pageid: "", uiname: "Tollfree Number" },
  ];
  constructor(props) {
    super(props);
    let action = props.action;
    let accountId = props.accountId;
    let tollfreeNumberId = props.tollfreeNumberId;
    if (!action && props.state) {
      action = props.state.action;
      accountId = props.state.accountId;
      tollfreeNumberId = props.state.tollfreeNumberId;
    }

    if (null !== tollfreeNumberId && tollfreeNumberId > 0) {
      this.getTollfreeNumber(accountId, tollfreeNumberId);
    }

    this.state = {
      action: action,
      accountId: accountId,
      tollfreeNumberId: tollfreeNumberId,
      phone: "",
      phoneNo: "",
      phoneSid: "",
      messageSid: "",
      mainSid: "",
      subaccountSid: "",
      subaccountFriendlyName: "",
      subaccountStatus: "",
      outgoingSmswebhook: "",
      incomingSmswebhook: "",
      verificationStatus: "",
      verificationSid: "",
      render: false,
      getUpdatePermission: false,
      getDeletePermission: false,
    };
  }
  getTollfreeNumber(accountId, tollfreeNumberId) {
    const postObject = {
      header: this.header,
      account: {
        id: accountId,
      },
      twilioNumber: {
        id: tollfreeNumberId,
      },
    };
    AdminFetchServerData.callPostService(
      "/apAccountms/getTollfreeNumber",
      postObject
    )
      .then((output) => {
        if (output.status === "SUCCESS") {
          let tollfreeNumberDetails = output.data.twilioNumber;
          let getPermission = Utils.getRolePermission(
            output.data.privilegeList
          );
          let getUpdatePermission = getPermission[3];
          let getDeletePermission = getPermission[4];
          let phoneNo =
            tollfreeNumberDetails?.phone !== null
              ? Utils.phoneNumberFormate(tollfreeNumberDetails?.phone)
              : "";
          this.setState({
            render: true,
            id: tollfreeNumberDetails.id,
            phone: tollfreeNumberDetails.phone,
            phoneNo: phoneNo,
            phoneSid: tollfreeNumberDetails.phoneSid,
            messageSid: tollfreeNumberDetails.messageSid,
            mainSid: tollfreeNumberDetails.mainSid,
            subaccountSid: tollfreeNumberDetails.subaccountSid,
            subaccountFriendlyName:
              tollfreeNumberDetails.subaccountFriendlyName,
            subaccountStatus: tollfreeNumberDetails.subaccountStatus,
            verificationStatus: tollfreeNumberDetails.verificationStatus,
            verificationSid: tollfreeNumberDetails.verificationSid,
            outgoingSmswebhook: tollfreeNumberDetails.outgoingSmswebhook,
            incomingSmswebhook: tollfreeNumberDetails.incomingSmswebhook,
            createdOn: Utils.getUtcToLocal(tollfreeNumberDetails.createdon),
            getUpdatePermission: getUpdatePermission,
            getDeletePermission: getDeletePermission,
          });
        }
      })
      .catch((error) => { });
  }

  handleCountryChange(phone, country, e, formattedValue) {
    this.setState({
      countryCode: formattedValue,
    });
  }

  handlePhoneChange(e) {
    let val = e.target.value;
    this.setState({
      phoneNo: val,
      phone: val,
    });
  }

  handlePhoneSIDChange(e) {
    this.setState({ phoneSid: e.target.value });
  }

  handleMessageSIDChange(e) {
    this.setState({ messageSid: e.target.value });
  }

  handleMainSIDChange(e) {
    this.setState({ mainSid: e.target.value });
  }

  handleSubAccountSIDChange(e) {
    this.setState({ subaccountSid: e.target.value });
  }

  handleSubAccountFriendlyNameChange(e) {
    this.setState({ subaccountFriendlyName: e.target.value });
  }
  handleSubAccountStatusChange(e) {
    this.setState({ subaccountStatus: e.target.value });
  }
  handleOutgoingSmsWebhookChange(e) {
    this.setState({ outgoingSmswebhook: e.target.value });
  }
  handleIncomingSmsWebhookChange(e) {
    this.setState({ incomingSmswebhook: e.target.value });
  }
  handleVerificationStatusChange(selectedValue) {
    this.setState({ verificationStatus: selectedValue });
  }
  handleVerificationSIDChange(e) {
    this.setState({ verificationSid: e.target.value });
  }

  editCancel() {
    this.setState({ action: "view", appUserId: this.state.id });
  }
  viewCancel() {
    this.props.navigate("/viewAccount", {
      state: {
        action: "view",
        accountId: this.state.accountId,
      },
    });
  }

  editTollfreeNumberDetails() {
    this.setState({ action: "edit" });
  }

  updateTollfreeNumberToBackend() {
    const postObject = {
      header: this.header,
      account: {
        id: this.state.accountId,
      },
      twilioNumber: {
        id: this.state.id,
        phone: this.state.phone,
        phoneSid: this.state.phoneSid,
        messageSid: this.state.messageSid,
        mainSid: this.state.mainSid,
        subaccountSid: this.state.subaccountSid,
        subaccountFriendlyName: this.state.subaccountFriendlyName,
        subaccountStatus: this.state.subaccountStatus,
        verificationStatus: this.state.verificationStatus,
        verificationSid: this.state.verificationSid,
      },
    };
    AdminFetchServerData.callPostService(
      "/apAccountms/updateTollfreeNumber",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        PtsAlert.success(output.message);
        let tollfreeNumberDetails = output.data.twilioNumber;
        this.getTollfreeNumber(this.state.accountId, tollfreeNumberDetails.id);
        this.setState({
          action: "view",
        });
      }
    });
  }

  deleteTollfreeNumberDetails() {
    const postObject = {
      header: this.header,
      appuser: {
        id: this.state.id,
      },
      twilioNumber: {
        id: this.state.id,
      },
    };

    AdminFetchServerData.callPostService(
      "/apAccountms/deleteTollfreeNumber",
      postObject
    )
      .then((output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          this.props.navigate("/appUserList");
        }
      })
      .catch((error) => { });
  }

  render() {
    if (this.state.action === "view") {
      return this.viewTollfreeNumber();
    } else if (this.state.action === "edit") {
      return this.editTollfreeNumber();
    }
  }

  viewTollfreeNumber() {
    if (this.state.render === false) {
      return <div />;
    } else {
      return (
        <>
          <AdminMenuWithBreadScrum
            breadCrumb={this.breadCrumb}
            history={this.props.history}
            name={this.title}
            domainObject={this.state.phoneNo}
            backCallback={this.viewCancel.bind(this)}
            editCallback={this.editTollfreeNumberDetails.bind(this)}
            deleteCallback={this.deleteTollfreeNumberDetails.bind(this)}
            getDeletePermission={this.state.getDeletePermission}
            getUpdatePermission={this.state.getUpdatePermission}
          />
          <div className="row" style={{ padding: "1em", marginTop: "-12px" }}>
            <div className="card" id="organizationFormCard">
              <div className="row">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="row pt-1">
                        <label
                          className="col-sm-2 col-form-label fw-bold"
                          htmlFor="basic-default-name"
                          id="assetFormLabel"
                        >
                          Phone
                        </label>
                        <div className="col-sm-10" id="OrganizationCol">
                          <span>{this.state.phone}</span>
                        </div>
                      </div>

                      <div className="row pt-1">
                        <label
                          className="col-sm-2 col-form-label fw-bold"
                          htmlFor="basic-default-name"
                          id="assetFormLabel"
                        >
                          Phone SID
                        </label>
                        <div className="col-sm-10" id="OrganizationCol">
                          <span>{this.state.phoneSid}</span>
                        </div>
                      </div>
                      <div className="row pt-1">
                        <label
                          className="col-sm-2 col-form-label fw-bold"
                          htmlFor="basic-default-name"
                          id="assetFormLabel"
                        >
                          Message SID
                        </label>
                        <div className="col-sm-10" id="OrganizationCol">
                          <span>{this.state.messageSid}</span>
                        </div>
                      </div>
                      <div className="row pt-1">
                        <label
                          className="col-sm-2 col-form-label fw-bold"
                          htmlFor="basic-default-name"
                          id="assetFormLabel"
                        >
                          Main SID
                        </label>
                        <div className="col-sm-10" id="OrganizationCol">
                          <span>{this.state.mainSid}</span>
                        </div>
                      </div>
                      <div className="row pt-1">
                        <label
                          className="col-sm-2 col-form-label fw-bold"
                          htmlFor="basic-default-name"
                          id="assetFormLabel"
                        >
                          Sub Account SID
                        </label>
                        <div className="col-sm-10" id="OrganizationCol">
                          <span>{this.state.subaccountSid}</span>
                        </div>
                      </div>
                      <div className="row pt-1">
                        <label
                          className="col-sm-2 col-form-label fw-bold"
                          htmlFor="basic-default-name"
                          id="assetFormLabel"
                        >
                          Sub Account Name
                        </label>
                        <div className="col-sm-10" id="OrganizationCol">
                          <span>{this.state.subaccountFriendlyName}</span>
                        </div>
                      </div>
                      <div className="row pt-1">
                        <label
                          className="col-sm-2 col-form-label fw-bold"
                          htmlFor="basic-default-name"
                          id="assetFormLabel"
                        >
                          Sub Account Status
                        </label>
                        <div className="col-sm-10" id="OrganizationCol">
                          <span>{this.state.subaccountStatus}</span>
                        </div>
                      </div>

                      <div className="row pt-1">
                        <label
                          className="col-sm-2 col-form-label fw-bold"
                          htmlFor="basic-default-name"
                          id="assetFormLabel"
                        >
                          Outgoing Sms webhook
                        </label>
                        <div className="col-sm-10" id="OrganizationCol">
                          <span>{this.state.outgoingSmswebhook}</span>
                        </div>
                      </div>
                      <div className="row pt-1">
                        <label
                          className="col-sm-2 col-form-label fw-bold"
                          htmlFor="basic-default-name"
                          id="assetFormLabel"
                        >
                          Incoming Sms webhook
                        </label>
                        <div className="col-sm-10" id="OrganizationCol">
                          <span>{this.state.incomingSmswebhook}</span>
                        </div>
                      </div>
                      <div className="row pt-1">
                        <label
                          className="col-sm-2 col-form-label fw-bold"
                          htmlFor="basic-default-name"
                          id="assetFormLabel"
                        >
                          verification Status
                        </label>
                        <div className="col-sm-10" id="OrganizationCol">
                          <span>{this.state.verificationStatus}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-4 text-center">
              <Button
                type="submit"
                variant="contained"
                size="small"
                style={{
                  background: "#717373",
                  color: "#fff",
                  marginRight: "1rem",
                  textTransform: "capitalize",
                }}
                startIcon={<ArrowBackIcon />}
                onClick={(e) => this.viewCancel()}
              >
                Back
              </Button>
            </div>
          </div>
        </>
      );
    }
  }
  editTollfreeNumber() {
    return (
      <>
        <AdminMenuWithBreadScrum
          breadCrumb={this.breadCrumb}
          history={this.props.history}
          name={this.title}
        />
        <div className="row">
          <ValidatorForm
            className="text-start"
            ref="form"
            onSubmit={this.updateTollfreeNumberToBackend.bind(this)}
          >
            <div className="row" style={{ marginTop: "1em" }}>
              <div className="col-md-12">
                <div className="card" id="organizationFormCard">
                  <div className="card-body">
                    <div className="row p-1">
                      <div className="col-md-4" id="assetFormLabel">
                        <label
                          className="form-label "
                          htmlFor="collapsible-firstname"
                        >
                          Phone*
                        </label>
                        <input
                          title=""
                          required
                          type="number"
                          autoComplete="off"
                          id="multiStepsFirstName"
                          name="multiStepsFirstName"
                          className="form-control"
                          value={this.state.phone}
                          onChange={this.handlePhoneChange.bind(this)}
                          validators={["required"]}
                          errormessages={["This field is required"]}
                        />
                      </div>
                    </div>
                    <div className="row p-1">
                      <div className="col-md-4" id="assetFormLabel">
                        <label
                          className="form-label "
                          htmlFor="collapsible-lastname"
                        >
                          Phone SID*
                        </label>
                        <input
                          title=""
                          required
                          type="text"
                          autoComplete="off"
                          id="multiStepsFirstName"
                          name="multiStepsFirstName"
                          className="form-control"
                          value={this.state.phoneSid}
                          onChange={this.handlePhoneSIDChange.bind(this)}
                          validators={["required"]}
                          errormessages={["This field is required"]}
                        />
                      </div>
                    </div>
                    <div className="row p-1">
                      <div className="col-md-4" id="assetFormLabel">
                        <label
                          className="form-label "
                          htmlFor="collapsible-text"
                        >
                          Message SID*
                        </label>
                        <input
                          title=""
                          required
                          type="text"
                          autoComplete="off"
                          id="multiStepsFirstName"
                          name="multiStepsFirstName"
                          className="form-control"
                          value={this.state.messageSid}
                          onChange={this.handleMessageSIDChange.bind(this)}
                          validators={["required"]}
                          errormessages={[
                            "This field is required",
                            "Email id is not valid",
                          ]}
                        />
                      </div>
                    </div>
                    <div className="row p-1">
                      <div className="col-md-4" id="assetFormLabel">
                        <label
                          className="form-label "
                          htmlFor="collapsible-text"
                        >
                          Main SID*
                        </label>
                        <input
                          title=""
                          required
                          type="text"
                          autoComplete="off"
                          id="multiStepsFirstName"
                          name="multiStepsFirstName"
                          className="form-control"
                          value={this.state.mainSid}
                          onChange={this.handleMainSIDChange.bind(this)}
                          validators={["required"]}
                          errormessages={[
                            "This field is required",
                            "Email id is not valid",
                          ]}
                        />
                      </div>
                    </div>
                    <div className="row p-1">
                      <div className="col-md-4" id="assetFormLabel">
                        <label
                          className="form-label "
                          htmlFor="collapsible-text"
                        >
                          Sub Account SID*
                        </label>
                        <input
                          title=""
                          required
                          type="text"
                          autoComplete="off"
                          id="multiStepsFirstName"
                          name="multiStepsFirstName"
                          className="form-control"
                          value={this.state.subaccountSid}
                          onChange={this.handleSubAccountSIDChange.bind(this)}
                          validators={["required"]}
                          errormessages={[
                            "This field is required",
                            "Email id is not valid",
                          ]}
                        />
                      </div>
                    </div>
                    <div className="row p-1">
                      <div className="col-md-4" id="assetFormLabel">
                        <label
                          className="form-label "
                          htmlFor="collapsible-text"
                        >
                          Sub Account Name
                          *
                        </label>
                        <input
                          title=""
                          required
                          type="text"
                          autoComplete="off"
                          id="multiStepsFirstName"
                          name="multiStepsFirstName"
                          className="form-control"
                          value={this.state.subaccountFriendlyName}
                          onChange={this.handleSubAccountFriendlyNameChange.bind(
                            this
                          )}
                          validators={["required"]}
                          errormessages={[
                            "This field is required",
                            "Email id is not valid",
                          ]}
                        />
                      </div>
                    </div >
                    <div className="row p-1">
                      <div className="col-md-4" id="assetFormLabel">
                        <label
                          className="form-label "
                          htmlFor="collapsible-text"
                        >
                          Sub Account Status
                          *
                        </label>
                        <input
                          title=""
                          required
                          type="text"
                          autoComplete="off"
                          id="multiStepsFirstName"
                          name="multiStepsFirstName"
                          className="form-control"
                          value={this.state.subaccountStatus}
                          onChange={this.handleSubAccountStatusChange.bind(
                            this
                          )}
                          validators={["required"]}
                          errormessages={[
                            "This field is required",
                            "Email id is not valid",
                          ]}
                        />
                      </div>
                    </div >
                    <div className="row p-1">
                      <div className="col-md-4" id="assetFormLabel">
                        <label
                          className="form-label "
                          htmlFor="collapsible-text"
                        >
                          Outgoing Sms Webhook
                          *
                        </label>
                        <input
                          title=""
                          required
                          type="text"
                          autoComplete="off"
                          id="multiStepsFirstName"
                          name="multiStepsFirstName"
                          className="form-control"
                          value={this.state.outgoingSmswebhook}
                          onChange={this.handleOutgoingSmsWebhookChange.bind(
                            this
                          )}
                          validators={["required"]}
                          errormessages={[
                            "This field is required",
                            "Email id is not valid",
                          ]}
                        />
                      </div>
                    </div >
                    <div className="row p-1">
                      <div className="col-md-4" id="assetFormLabel">
                        <label
                          className="form-label "
                          htmlFor="collapsible-text"
                        >
                          Incoming Sms Webhook
                          *
                        </label>
                        <input
                          required
                          title=""
                          type="text"
                          autoComplete="off"
                          id="multiStepsFirstName"
                          name="multiStepsFirstName"
                          className="form-control"
                          value={this.state.incomingSmswebhook}
                          onChange={this.handleIncomingSmsWebhookChange.bind(
                            this
                          )}
                          validators={["required"]}
                          errormessages={[
                            "This field is required",
                            "Email id is not valid",
                          ]}
                        />
                      </div>
                    </div >
                    <div className="row p-1">
                      <div className="col-md-4" id="assetFormLabel">
                        <label
                          className="form-label "
                          htmlFor="collapsible-text"
                        >
                          verification Status
                          *
                        </label>
                        {/* <input
                          required
                          type="text"
                          autoComplete="off"
                          id="multiStepsFirstName"
                          name="multiStepsFirstName"
                          className="form-control"
                          value={this.state.verificationStatus}
                          onChange={this.handleVerificationStatusChange.bind(
                            this
                          )}
                          validators={["required"]}
                          errormessages={[
                            "This field is required",
                            "Email id is not valid",
                          ]}
                        /> */}
                        <Autocomplete
                          id="size-small-outlined"
                          size="small"
                          fullWidth
                          disableClearable
                          autoComplete="off"
                          options={["Created", "Approved"]}
                          value={this.state.verificationStatus}
                          getOptionLabel={(option) => option}
                          defaultValue={this.state.verificationStatus}
                          onChange={(event, value) => {
                            this.handleVerificationStatusChange(value);
                          }}
                          inputprops={{
                            style: { textTransform: "capitalize" },
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Please Select"
                              variant="outlined"
                              size="small"
                              className="autoComplete"
                              style={{ background: "#fff" }}
                            />
                          )}
                        />
                      </div>
                    </div >
                    {/* <div className="row p-1">
                      <div className="col-md-4" id="assetFormLabel">
                        <label
                          className="form-label "
                          htmlFor="collapsible-text"
                        >
                          Verification SID
                          *
                        </label>
                        <input
                          //   required
                          type="text"
                          autoComplete="off"
                          id="multiStepsFirstName"
                          name="multiStepsFirstName"
                          className="form-control"
                          value={this.state.verificationSid}
                          onChange={this.handleVerificationSIDChange.bind(this)}
                          validators={["required"]}
                          errormessages={[
                            "This field is required",
                            "Email id is not valid",
                          ]}
                        />
                      </div>
                    </div> */}
                  </div >
                </div >
              </div >
            </div >
            <div className="row d-flex align-items-center justify-content-between">
              <div className="col-sm-12 mt-3 text-center">
                <SaveButton id="saveButton" type="submit">
                  {" "}
                  Save{" "}
                </SaveButton>
                &nbsp;&nbsp;
                <CancelIconButton onClick={(e) => this.editCancel()} />
              </div>
            </div>
          </ValidatorForm >
        </div >
      </>
    );
  }
}
export default withRouter(AccountTollfreeNumber);
